
import { supabase } from "@/integrations/supabase/client";

export const copyRoutineWithExercises = async (routine: any, userId: string) => {
  console.log("Copying routine:", routine);
  
  try {
    // Create new routine - removed the "(Copia)" suffix
    const { data: newRoutine, error: routineError } = await supabase
      .from('routines')
      .insert({
        name: routine.name,
        user_id: userId
      })
      .select()
      .single();

    if (routineError) throw routineError;
    console.log("Created new routine:", newRoutine);

    // Copy routine days
    const { data: routineDays, error: daysQueryError } = await supabase
      .from("routine_days")
      .select("day")
      .eq("routine_id", routine.id);
      
    if (daysQueryError) {
      console.error("Error fetching routine days:", daysQueryError);
    } else if (routineDays && routineDays.length > 0) {
      const dayData = routineDays.map(rd => ({
        routine_id: newRoutine.id,
        day: rd.day
      }));
      
      const { error: daysError } = await supabase
        .from("routine_days")
        .insert(dayData);
        
      if (daysError) {
        console.error("Error copying routine days:", daysError);
      } else {
        console.log("Copied routine days successfully");
      }
    }

    // Get exercises from the original routine if not provided directly
    let exercisesToCopy = routine.exercises;
    if (!exercisesToCopy) {
      const { data: exercises, error: exercisesQueryError } = await supabase
        .from("exercises")
        .select("*")
        .eq("routine_id", routine.id);
        
      if (exercisesQueryError) {
        console.error("Error fetching exercises:", exercisesQueryError);
      } else {
        exercisesToCopy = exercises;
      }
    }

    if (exercisesToCopy?.length) {
      // Prepare exercises data for the new routine
      const exercisesData = exercisesToCopy.map((exercise: any) => ({
        routine_id: newRoutine.id,
        name: exercise.name,
        sets: exercise.sets,
        reps: exercise.reps,
        weight: exercise.weight,
        position: exercise.position || 1,
        exercise_rest_time: exercise.exercise_rest_time,
        set_rest_time: exercise.set_rest_time,
        video_url: exercise.video_url,
        set_data: exercise.set_data || []
      }));

      // Insert exercises
      const { error: exercisesError } = await supabase
        .from('exercises')
        .insert(exercisesData);

      if (exercisesError) {
        console.error("Error copying exercises:", exercisesError);
      } else {
        console.log("Copied exercises for routine successfully");
      }
    }

    return newRoutine;
  } catch (error) {
    console.error("Error in copyRoutineWithExercises:", error);
    throw error;
  }
};
